module.exports = __webpack_public_path__ + "img/pCorte2.e4f0b4c1.jpg";